import { TripStep } from "../../interfaces/trip-step.interface"
import { isDefined } from "../is-defined"
import { TripStepDetailsByVehicle } from "../../interfaces/trip-step-details-vehicle.interface"

export const isVehicle = (
  step: TripStep
): step is TripStep<TripStepDetailsByVehicle> =>
  isDefined((step.details as TripStepDetailsByVehicle).provider)
